module.exports = __webpack_public_path__ + "img/car.eacb996e.svg";